import { Component } from 'react';
import { NavLink } from 'react-router-dom';
import { withRouter } from '../../util/withRouter';
import Button from '@mui/material/Button';

import IntlMessages from '../../util/IntlMessages';
import CustomScrollbars from '../../util/CustomScrollbars';

class SidenavContent extends Component {
  componentDidMount() {
    this.setupMenuHandlers();
    this.updateActiveNav();
  }

  componentDidUpdate(prevProps) {
    if (this.props.location.pathname !== prevProps.location.pathname) {
      this.updateActiveNav();
    }
  }

  updateActiveNav = () => {
    const { location } = this.props;
    const pathname = location.pathname;

    setTimeout(() => {
      const activeLi =
        document.querySelector(`a[href="${pathname}"]`) ||
        document.querySelector(`a[href="#${pathname}"]`) ||
        document.querySelector('.sub-menu a.active');

      if (activeLi) {
        try {
          const activeNav = this.closest(activeLi, 'ul');
          if (activeNav && activeNav.classList.contains('sub-menu')) {
            const parentMenu = this.closest(activeNav, 'li');
            if (parentMenu) {
              parentMenu.classList.add('open');
            }
          }
        } catch (error) {}
      }
    }, 50);
  };

  setupMenuHandlers = () => {
    const that = this;
    const subMenuLi = document.querySelectorAll('.sub-menu > li');
    for (let i = 0; i < subMenuLi.length; i++) {
      subMenuLi[i].onclick = function (event) {
        event.stopPropagation();
      };
    }

    const menuLi = document.getElementsByClassName('menu');
    for (let i = 0; i < menuLi.length; i++) {
      menuLi[i].onclick = function (event) {
        for (let j = 0; j < menuLi.length; j++) {
          const parentLi = that.closest(this, 'li');
          if (menuLi[j] !== this && (parentLi === null || !parentLi.classList.contains('open'))) {
            menuLi[j].classList.remove('open');
          }
        }
        this.classList.toggle('open');
        event.stopPropagation();
      };
    }
  };

  closest(el, selector) {
    try {
      let parent = el;
      while (parent) {
        if (parent && parent.matches && parent.matches(selector)) {
          return parent;
        }
        parent = parent.parentElement;
      }
    } catch (e) {}
    return null;
  }

  render() {
    return (
      <CustomScrollbars className=" scrollbar">
        <ul className="nav-menu">
          <li>
            <NavLink to="/app/dashboard/index">
              <i className="zmdi zmdi-view-dashboard zmdi-hc-fw" />
              <span className="nav-text">
                <IntlMessages id="sidebar.dashboard" />
              </span>
            </NavLink>
          </li>
          <li>
            <NavLink to="/app/customers/list">
              <i className="zmdi zmdi-accounts-alt zmdi-hc-fw" />
              <span className="nav-text">
                <IntlMessages id="sidebar.customers" />
              </span>
            </NavLink>
          </li>
          <li>
            <NavLink
              to="/app/drivers/list"
              className={({ isActive }) =>
                isActive &&
                !(
                  this.props.location.pathname === '/app/drivers/list' &&
                  this.props.location.search.includes('fleetPartnerId')
                )
                  ? 'active'
                  : ''
              }
            >
              <i className="zmdi zmdi-local-taxi zmdi-hc-fw" />
              <span className="nav-text">
                <IntlMessages id="sidebar.drivers" />
              </span>
            </NavLink>
          </li>

          <li>
            <NavLink to="/app/all/vehicles">
              <i className="zmdi zmdi-bus zmdi-hc-fw" />
              <span className="nav-text">
                <IntlMessages id="Vehicles" />
              </span>
            </NavLink>
          </li>

          <li>
            <NavLink
              to="/app/partners/list"
              className={({ isActive }) =>
                `prepend-icon cbutton ${isActive || (this.props.location.pathname === '/app/drivers/list' && this.props.location.search.includes('fleetPartnerId')) || this.props.location.pathname.startsWith('/app/invoice/list/') || this.props.location.pathname.startsWith('/app/partners/') ? 'active' : ''}`
              }
            >
              <i className="zmdi zmdi-account zmdi-hc-fw" />
              <span className="nav-text">
                <IntlMessages id="sidebar.partners" />
              </span>
            </NavLink>
          </li>

          <li>
            <NavLink className="prepend-icon cbutton" to="/app/reviews/list">
              <i className="zmdi zmdi-star zmdi-hc-fw" />
              <span className="nav-text">Reviews</span>
            </NavLink>
          </li>

          <li className="menu collapse-box">
            <Button
              href="javascript:void(0)"
              className="cbutton"
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
                const parentLi = e.currentTarget.closest('li');
                if (parentLi) {
                  const menuLi = document.getElementsByClassName('menu');
                  for (let j = 0; j < menuLi.length; j++) {
                    if (menuLi[j] !== parentLi) {
                      menuLi[j].classList.remove('open');
                    }
                  }
                  parentLi.classList.toggle('open');
                }
              }}
            >
              <i className="zmdi zmdi-swap-vertical-circle zmdi-hc-fw" />
              <span className="nav-text">
                <IntlMessages id="sidebar.trips" />
              </span>
            </Button>
            <ul className="sub-menu">
              <li>
                <NavLink className="prepend-icon cbutton" to="/app/trips/list">
                  <i className="zmdi zmdi-receipt" />
                  <span className="nav-text">
                    <IntlMessages id="sidebar.all" />
                  </span>
                </NavLink>
              </li>
              <li>
                <NavLink className="prepend-icon cbutton" to="/app/trips/completed">
                  <i className="zmdi zmdi-receipt" />
                  <span className="nav-text">
                    <IntlMessages id="sidebar.completed" />
                  </span>
                </NavLink>
              </li>
              <li>
                <NavLink className="prepend-icon cbutton" to="/app/trips/new">
                  <i className="zmdi zmdi-receipt" />
                  <span className="nav-text">
                    <IntlMessages id="sidebar.canceled" />
                  </span>
                </NavLink>
              </li>
              <li>
                <NavLink className="prepend-icon cbutton" to="/app/trips/missed">
                  <i className="zmdi zmdi-receipt" />
                  <span className="nav-text">
                    <IntlMessages id="Missed" />
                  </span>
                </NavLink>
              </li>
              <li>
                <NavLink className="prepend-icon cbutton" to="/app/trips/promo">
                  <i className="zmdi zmdi-receipt" />
                  <span className="nav-text">
                    <IntlMessages id="Promo" />
                  </span>
                </NavLink>
              </li>
              <li>
                <NavLink className="prepend-icon cbutton" to="/app/trips/selfride">
                  <i className="zmdi zmdi-receipt" />
                  <span className="nav-text">
                    <IntlMessages id="Self Ride" />
                  </span>
                </NavLink>
              </li>
              <li>
                <NavLink className="prepend-icon cbutton" to="/app/trips/selfridecustomer">
                  <i className="zmdi zmdi-receipt" />
                  <span className="nav-text">
                    <IntlMessages id="Self Ride Customer" />
                  </span>
                </NavLink>
              </li>
              <li>
                <NavLink className="prepend-icon cbutton" to="/app/trips/customerride">
                  <i className="zmdi zmdi-receipt" />
                  <span className="nav-text">
                    <IntlMessages id="Customer Ride" />
                  </span>
                </NavLink>
              </li>
              <li>
                <NavLink className="prepend-icon cbutton" to="/app/trips/cartype">
                  <i className="zmdi zmdi-receipt" />
                  <span className="nav-text">
                    <IntlMessages id="Car Type" />
                  </span>
                </NavLink>
              </li>
              {/* <li>
                <NavLink className="prepend-icon cbutton" to="/app/trips/locations">
                  <i className="zmdi zmdi-receipt" />
                  <span className="nav-text">
                    <IntlMessages id="sidebar.locations" />
                  </span>
                </NavLink>
              </li> */}
            </ul>
          </li>

          <li>
            <NavLink to="/app/advertisement">
              <i className="zmdi zmdi-copy zmdi zmdi-widgets" />
              <span className="nav-text">
                <IntlMessages id="sidebar.advertisement" />{' '}
              </span>
            </NavLink>
          </li>
          <li>
            <NavLink to="/app/car-types">
              <i className="zmdi zmdi-copy zmdi-hc-fw" />
              <span className="nav-text">
                <IntlMessages id="sidebar.carTypes" />{' '}
              </span>
            </NavLink>
          </li>
          <li>
            <NavLink to="/app/geofencing/list">
              <i className="zmdi zmdi-map zmdi-hc-fw" />
              <span className="nav-text">
                <IntlMessages id="sidebar.geoFencing" />{' '}
              </span>
            </NavLink>
          </li>
          <li>
            <NavLink to="/app/promo-codes/list">
              <i className="zmdi zmdi-label zmdi-hc-fw" />
              <span className="nav-text">
                <IntlMessages id="sidebar.promocodes" />
              </span>
            </NavLink>
          </li>
          <li>
            <NavLink to="/app/notification">
              <i className="zmdi zmdi-notifications-active zmdi-hc-fw" />
              <span className="nav-text">
                <IntlMessages id="sidebar.notification" />
              </span>
            </NavLink>
          </li>
          <li>
            <NavLink to="/app/contentPages">
              <i className="zmdi zmdi-file-text zmdi-hc-fw" />
              <span className="nav-text">
                <IntlMessages id="sidebar.pages" />
              </span>
            </NavLink>
          </li>
          <li>
            <NavLink to="/app/faq">
              <i className="zmdi zmdi-comments zmdi-hc-fw" />
              <span className="nav-text">
                <IntlMessages id="sidebar.faq" />
              </span>
            </NavLink>
          </li>
          <li className="menu collapse-box">
            <Button
              href="javascript:void(0)"
              className="cbutton"
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
                const parentLi = e.currentTarget.closest('li');
                if (parentLi) {
                  const menuLi = document.getElementsByClassName('menu');
                  for (let j = 0; j < menuLi.length; j++) {
                    if (menuLi[j] !== parentLi) {
                      menuLi[j].classList.remove('open');
                    }
                  }
                  parentLi.classList.toggle('open');
                }
              }}
            >
              <i className="zmdi zmdi-settings zmdi-hc-fw" />
              <span className="nav-text">
                <IntlMessages id="sidebar.settings" />
              </span>
            </Button>
            <ul className="sub-menu">
              <li>
                <NavLink className="prepend-icon cbutton" to="/app/users/list">
                  <i className="zmdi zmdi-account" />
                  <span className="nav-text">
                    <IntlMessages id="sidebar.admin" />
                  </span>
                </NavLink>
              </li>
              <li>
                <NavLink className="prepend-icon cbutton" to="/app/settings/basic">
                  <i className="zmdi zmdi-album"></i>

                  <span className="nav-text">
                    <IntlMessages id="setting.basic" />
                  </span>
                </NavLink>
              </li>

              <li>
                <NavLink className="prepend-icon cbutton" to="/app/settings/installation">
                  <i className="zmdi zmdi-remote-control"></i>

                  <span className="nav-text">
                    <IntlMessages id="setting.installation" />
                  </span>
                </NavLink>
              </li>

              <li>
                <NavLink className="prepend-icon cbutton" to="/app/banner/list">
                  <i className="zmdi zmdi-assignment"></i>

                  <span className="nav-text">
                    <IntlMessages id="Manage Banner" />
                  </span>
                </NavLink>
              </li>

              <li>
                <NavLink className="prepend-icon cbutton" to="/app/settings/mail">
                  <i className="zmdi zmdi-email"></i>

                  <span className="nav-text">
                    <IntlMessages id="template.mail" />
                  </span>
                </NavLink>
              </li>
              <li>
                <NavLink className="prepend-icon cbutton" to="/app/settings/sms">
                  <i className="zmdi zmdi-comment-text"></i>

                  <span className="nav-text">
                    <IntlMessages id="template.sms" />
                  </span>
                </NavLink>
              </li>
            </ul>
          </li>
        </ul>
      </CustomScrollbars>
    );
  }
}

export default withRouter(SidenavContent);
